<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <span *ngIf="mode === 'create'">{{ "title.create_field" | translate }}</span>
  <span *ngIf="mode === 'edit'">{{ "title.edit_field" | translate }}</span>
  <button type="button" class="close" aria-label="Close" mat-dialog-close>
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography" style="max-height: 65vh;">
  <section>
    <form [formGroup]="mainFormGroup" (submit)="submitForm()">
      <div class="row pt-3 mt-3">
        <div class="col-12 d-flex">
          <div class="check-box">
            <mat-form-field class="no-underline">
              <label class="mr-2">{{
                "document_template.lbl_is_group" | translate
              }}</label>
              <mat-slide-toggle
                color="primary"
                style="vertical-align: middle; margin-left: 10px"
                formControlName="isGroup"
                (change)="onChangeIsGroup($event)"
              ></mat-slide-toggle>
              <input matInput hidden />
            </mat-form-field>
          </div>
          <div
            class="ml-4 check-box"
            *ngIf="mainFormGroup?.controls?.isGroup?.value"
          >
            <mat-form-field class="no-underline">
              <mat-checkbox color="primary" formControlName="isMultipleGroup" [disabled]="!mainFormGroup.controls.nameGroup.value">{{
                "document_template.lbl_is_multiple_group" | translate
              }}</mat-checkbox>
              <input matInput hidden />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-3 required"
          [class.required-error]="isError('name', 'required')"
        >
          <mat-form-field>
            <input
              (focusout)="focusOut('name')"
              matInput
              type="text"
              maxlength="200"
              formControlName="name"
              placeholder="{{ 'document_template.lbl_name_field' | translate }}"
            />
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.name.value"
              (click)="clearData('name')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="isError('name', 'required')">
              {{ "document_template.lbl_name_field" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-3" *ngIf="mainFormGroup?.controls?.isGroup?.value">
          <mat-form-field>
            <input
              matInput
              type="text"
              formControlName="nameGroup"
              maxlength="200"
              placeholder="{{ 'document_template.lbl_name_group' | translate }}"
            />
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.nameGroup.value"
              (click)="clearData('nameGroup')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="isError('nameGroup', 'duplicate')">
              {{ "document_template.check_name_group_exist" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-3" *ngIf="mainFormGroup?.controls?.isGroup?.value">
          <mat-form-field>
            <input
              matInput
              type="text"
              formControlName="mergeFieldStart"
              [placeholder]="
                'document_template.lbl_merge_field_start' | translate
              "
              [readonly]="true"
            />
          </mat-form-field>
        </div>
        <div class="col-3" *ngIf="mainFormGroup?.controls?.isGroup?.value">
          <mat-form-field>
            <input
              matInput
              type="text"
              formControlName="mergeFieldEnd"
              [placeholder]="
                'document_template.lbl_merge_field_end' | translate
              "
              [readonly]="true"
            />
          </mat-form-field>
        </div>
        <div
          class="col-6"
          *ngIf="!mainFormGroup?.controls?.isGroup?.value"
          [class.required]="mainFormGroup.controls.editorSignatureId.value"
          [class.required-error]="isError('mergeField', 'required')"
        >
          <mat-form-field>
            <input
              (focusout)="focusOut('mergeField')"
              matInput
              type="text"
              maxlength="200"
              formControlName="mergeField"
              [placeholder]="'document_template.lbl_merge_field' | translate"
            />
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.mergeField.value"
              (click)="clearData('mergeField')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error
              *ngIf="isError('mergeField', 'required')"
            >
              {{ "document_template.validate_merge_field_customer_edit_required" | translate }}
            </mat-error>
            <mat-error
              *ngIf="mainFormGroup.controls.mergeField.errors?.mergeFieldExist"
            >
              {{
                "document_template.check_merge_field_config_exist" | translate
              }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-3" *ngIf="!mainFormGroup?.controls?.isGroup?.value">
          <mat-form-field>
            <mat-select
              formControlName="group"
              [placeholder]="'document_template.lbl_group' | translate"
            >
              <mat-option [value]="null">
                -- {{ "document_template.lbl_select" | translate }} --
              </mat-option>
              <mat-option
                *ngFor="let group of listGroup"
                [value]="group.fieldConfigId"
                [class.animation]="group?.name?.length > 39"
              >
                {{ group?.name }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.group.value"
              (click)="clearData('group')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="!mainFormGroup?.controls?.isGroup?.value">
        <div
          class="col-3 required"
          [class.required-error]="isError('dataType', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="dataType"
              placeholder="{{ 'document_template.lbl_type_input' | translate }}"
              (selectionChange)="onChangeDataType($event)"
            >
              <mat-option
                *ngFor="let dataType of listDataTypes"
                [value]="dataType.code"
                [class.animation]="dataType?.name?.length > 39"
              >
                {{ dataType?.name }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.dataType.value"
              (click)="clearData('dataType')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
            <mat-error *ngIf="isError('dataType', 'required')">
              {{ "document_template.lbl_type_input" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="
            mainFormGroup?.controls?.dataType?.value ===
              DATA_TYPE_REF_CUSTOMER ||
            mainFormGroup?.controls?.dataType?.value === DATA_TYPE_REF
          "
          [class.required-error]="isError('relatedFieldCode', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="relatedFieldCode"
              [placeholder]="
                (mainFormGroup?.controls?.dataType?.value === DATA_TYPE_REF
                  ? 'document_template.lbl_ref_field'
                  : 'document_template.lbl_related_data_field'
                ) | translate
              "
              (selectionChange)="onChangeRelatedFieldCode($event)"
            >
              <mat-option
                *ngFor="let field of relatedField"
                [value]="field.code"
                [class.animation]="field?.name?.length > 39"
              >
                {{ field?.name }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.relatedFieldCode.value"
              (click)="clearData('relatedFieldCode')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
            <mat-error *ngIf="isError('relatedFieldCode', 'required')">
              {{
                (mainFormGroup?.controls?.dataType?.value === DATA_TYPE_REF
                  ? "document_template.lbl_ref_field"
                  : "document_template.lbl_related_data_field"
                ) | translate
              }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="mainFormGroup?.controls?.dataType?.value === DATA_TYPE_REF"
          [class.required-error]="isError('relatedFieldCode', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="refCategory"
              [placeholder]="'document_template.lbl_ref_category' | translate"
              (selectionChange)="onChangeRefCategory($event)"
            >
              <mat-option
                *ngFor="let category of listCategories"
                [value]="category.categoryId"
                [matTooltip]="category.name"
              >
                {{ category?.name }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.refCategory.value"
              (click)="clearData('refCategory')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
            <mat-error *ngIf="isError('refCategory', 'required')">
              {{ "document_template.lbl_ref_category" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="
            mainFormGroup?.controls?.dataType?.value ===
              DATA_TYPE_REF_CUSTOMER ||
            mainFormGroup?.controls?.dataType?.value ===
              DATA_TYPE_REF_ENTERPRISE
          "
          [class.required-error]="isError('refCategoryField', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="refCategoryField"
              placeholder="
                {{ 'document_template.lbl_ref_category_field' | translate }}
              "
              [disabled]="
                !mainFormGroup?.controls?.refCategory?.value &&
                mainFormGroup?.controls?.dataType?.value === DATA_TYPE_REF
              "
            >
              <ngx-mat-select-search
                [formControl]="searchCategoryFieldCtrl"
                placeholderLabel="Nhập trường tham chiếu"
                noEntriesFoundLabel="Không có kết quả!"
              ></ngx-mat-select-search>
              <mat-option
                *ngFor="let field of listCategoryField | async; let i = index"
                [value]="field.categoryFieldId"
                [class.animation]="field?.name?.length > 39"
              >
                {{ field?.name }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.refCategoryField.value"
              (click)="clearData('refCategoryField')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
            <mat-error *ngIf="isError('refCategoryField', 'required')">
              {{ "document_template.lbl_ref_category_field" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="
            mainFormGroup?.controls?.dataType?.value &&
            mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_FIXED &&
            mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_CURRENCY &&
            mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_CUSTOMER &&
            mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_CONTRACT_CODE
          "
          [class.required-error]="isError('type', 'required')"
        >
          <mat-form-field
          >
            <mat-select
              formControlName="type"
              [placeholder]="
                mainFormGroup?.controls?.dataType?.value !==
                  DATA_TYPE_REF_CUSTOMER &&
                mainFormGroup?.controls?.dataType?.value !==
                  DATA_TYPE_REF_ENTERPRISE &&
                mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_REF &&
                mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_FORMULA
                  ? ('document_template.lbl_data_type' | translate)
                  : ('document_template.lbl_ui_field' | translate)
              "
              (selectionChange)="onChangeFieldType()"
            >
              <mat-option
                *ngFor="let type of listTypes"
                [value]="type.code"
                [class.animation]="type?.name?.length > 39"
              >
                {{ type?.name }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.type.value"
              (click)="clearData('type')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
            <mat-error *ngIf="isError('type', 'required')">
              {{
                mainFormGroup?.controls?.dataType?.value !==
                  DATA_TYPE_REF_CUSTOMER &&
                mainFormGroup?.controls?.dataType?.value !==
                  DATA_TYPE_REF_ENTERPRISE &&
                mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_REF &&
                mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_FORMULA
                  ? ("document_template.lbl_data_type" | translate)
                  : ("document_template.lbl_ui_field" | translate)
              }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="
            (mainFormGroup?.controls?.type?.value === FIELD_TYPE_COMBOBOX ||
              mainFormGroup?.controls?.type?.value === FIELD_TYPE_CHECKBOX ||
              mainFormGroup?.controls?.type?.value === FIELD_TYPE_RADIO) &&
            (mainFormGroup?.controls?.dataType?.value === DATA_TYPE_SELECT ||
              mainFormGroup?.controls?.dataType?.value === DATA_TYPE_CURRENCY)
          "
          [class.required-error]="isError('category', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="category"
              placeholder="{{
                'document_template.lbl_category_field' | translate
              }}"
              (selectionChange)="onChangeCategories($event)"
            >
              <mat-option
                *ngFor="let category of listCategories"
                [value]="category.categoryId"
                [matTooltip]="category.name"
              >
                {{ category?.name }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.category.value"
              (click)="clearData('category')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
            <mat-error *ngIf="isError('category', 'required')">
              {{ "document_template.lbl_category_field" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3"
          *ngIf="
            mainFormGroup?.controls?.dataType?.value === DATA_TYPE_INPUT ||
            mainFormGroup?.controls?.dataType?.value === DATA_TYPE_CURRENCY ||
            (mainFormGroup?.controls?.dataType?.value === DATA_TYPE_SELECT &&
              (!mainFormGroup?.controls?.category?.value ||
                mainFormGroup?.controls?.category?.value !==
                  customerCategoryId))
          "
        >
          <mat-form-field
            *ngIf="
              mainFormGroup.controls.type.value !== 'date' &&
              mainFormGroup.controls.dataType?.value !== DATA_TYPE_SELECT &&
              mainFormGroup.controls.dataType?.value !== DATA_TYPE_CURRENCY
            "
          >
            <input
              (focusout)="focusOut('defaultValue')"
              [ngModel]="
                mainFormGroup.controls.type.value === 'number_money_format'
                  ? (mainFormGroup.controls.defaultValue.value
                    | numberWithCommas)
                  : mainFormGroup.controls.defaultValue.value
              "
              matInput
              id="defaultValue"
              type="text"
              maxlength="200"
              formControlName="defaultValue"
              [placeholder]="'document_template.lbl_default_value' | translate"
            />
            <mat-error *ngIf="isError('defaultValue', 'inValid')">
              {{ "document_template.error_default_value" | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field
            *ngIf="
              mainFormGroup.controls.dataType?.value === DATA_TYPE_SELECT ||
              mainFormGroup.controls.dataType?.value === DATA_TYPE_CURRENCY
            "
          >
            <mat-select
              formControlName="defaultValue"
              placeholder="{{
                'document_template.lbl_default_value' | translate
              }}"
            >
              <mat-option [value]="null">
                -- {{ "document_template.lbl_select" | translate }} --
              </mat-option>
              <mat-option
                *ngFor="let data of listDataCategories"
                [value]="data.value"
                [class.animation]="data?.value?.length > 39"
              >
                {{ data?.value }}
              </mat-option>
            </mat-select>
            <!-- <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.category.value"
              (click)="clearData('category')"
            >
              <mat-icon>close</mat-icon>
            </button> -->
            <mat-error *ngIf="isError('category', 'required')">
              {{ "document_template.lbl_default_value" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="mainFormGroup.controls.type.value === 'date'">
            <input
              matInput
              id="defaultValue"
              maxlength="10"
              formControlName="defaultValue"
              [placeholder]="'document_template.lbl_default_value' | translate"
              (change)="
                this.commonService.resetDatePicker(
                  pickerInput2.value,
                  this.mainFormGroup.controls['defaultValue']
                )
              "
              [matDatepicker]="picker1"
              #pickerInput2
            />
            <mat-datepicker-toggle matSuffix [for]="picker1">
              <i
                matDatepickerToggleIcon
                class="fa fa-calendar"
                aria-hidden="true"
                [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"
              ></i>
            </mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.defaultValue.value"
              (click)="clearData('defaultValue')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error
              *ngIf="
                isError('defaultValue', 'matDatepickerParse') &&
                mainFormGroup?.controls?.type?.value === 'date'
              "
            >
              {{ "document_template.error_default_value" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Cấu hình cho phép khách hàng chỉnh sửa  -->
        <div
          class="col-3"
          *ngIf="mainFormGroup?.controls?.dataType?.value === DATA_TYPE_INPUT || mainFormGroup?.controls?.dataType?.value === DATA_TYPE_REF_CUSTOMER || mainFormGroup?.controls?.dataType?.value === DATA_TYPE_SELECT"
        >
          <mat-form-field>
            <mat-select
              formControlName="editorSignatureId"
              placeholder="{{
                'document_template.lbl_signature_field' | translate
              }}"
            >
              <mat-option
                [value]="null"
              >
                -- {{ "document_template.lbl_select" | translate }} --
              </mat-option>
              <mat-option
                *ngFor="let editorSignature of listSignatureConfigCustomer"
                [value]="editorSignature.signatureId"
                [matTooltip]="editorSignature.name"
              >
                {{ editorSignature?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="mainFormGroup?.controls?.dataType?.value === DATA_TYPE_FIXED"
          [class.required-error]="isError('fixedFunction', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="fixedFunction"
              placeholder="{{
                'document_template.lbl_fixed_function' | translate
              }}"
              (selectionChange)="onChangeFixedFunction($event)"
            >
              <mat-option
                *ngFor="let func of listFixedFunctions"
                [value]="func.code"
                [class.animation]="func?.name?.length > 39"
              >
                {{ func?.name }}
              </mat-option>
            </mat-select>
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.fixedFunction.value"
              (click)="clearData('fixedFunction')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="isError('fixedFunction', 'required')">
              {{ "document_template.lbl_fixed_function" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="mainFormGroup?.controls?.dataType?.value === DATA_TYPE_FIXED"
          [class.required-error]="isError('fixedFieldCode', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="fixedFieldCode"
              placeholder="{{
                'document_template.lbl_fixed_field' | translate
              }}"
            >
              <mat-option
                *ngFor="let field of fixedFields"
                [value]="field.code"
                [class.animation]="field?.name?.length > 39"
              >
                {{ field?.name }}
              </mat-option>
            </mat-select>
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.fixedFieldCode.value"
              (click)="clearData('fixedFieldCode')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="isError('fixedFieldCode', 'required')">
              {{ "document_template.lbl_fixed_field" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-3 required"
          *ngIf="
            mainFormGroup?.controls?.dataType?.value === DATA_TYPE_FIXED &&
            mainFormGroup?.controls?.fixedFunction?.value ===
              NUMBER_TO_MONEY_TEXT
          "
          [class.required-error]="isError('fixedMoneyFieldCode', 'required')"
        >
          <mat-form-field>
            <mat-select
              formControlName="fixedMoneyFieldCode"
              placeholder="{{
                'document_template.lbl_fixed_money_field' | translate
              }}"
            >
              <mat-option
                *ngFor="let field of listMoneyData"
                [value]="field.description"
                [class.animation]="field?.name?.length > 39"
              >
                {{ field?.name }}
              </mat-option>
            </mat-select>
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.fixedMoneyFieldCode.value"
              (click)="clearData('fixedMoneyFieldCode')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="isError('fixedMoneyFieldCode', 'required')">
              {{ "document_template.lbl_fixed_money_field" | translate }}
              {{ "document_template.validate_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div
        class="row"
        *ngIf="mainFormGroup?.controls?.dataType?.value === DATA_TYPE_FORMULA"
      >
        <div class="col-7">
          <mat-form-field>
            <textarea
              matInput
              name="formula"
              id="formula"
              rows="5"
              formControlName="formula"
              [placeholder]="'document_template.lbl_formula' | translate"
              maxlength="4000"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="col-5">
          <h4>{{ "document_template.lbl_list_field" | translate }}</h4>
          <input
            matInput
            type="text"
            [formControl]="fieldFormulaName"
            [placeholder]="
              'document_template.lbl_search_field_formula' | translate
            "
          />
          <div class="box-field-search">
            <a *ngFor="let row of listRows | async" (click)="onClickField(row)"
              >{{ row.position }} - {{ row.name }}</a
            >
            <div class="no-record" *ngIf="!(listRows | async)?.length">
              <p>{{ "form.no_record" | translate }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!mainFormGroup?.controls?.isGroup?.value">
        <div class="col-12">
          <h4 class="font-weight-bold">
            {{ "title.difference_options" | translate }}
          </h4>
        </div>
        <div class="col-3">
          <mat-form-field class="no-underline">
            <label class="mr-2"></label>
            <mat-checkbox
              color="primary"
              formControlName="isHidden"
              (change)="onChangeIsHidden($event)"
              >{{ "document_template.lbl_is_hidden" | translate }}</mat-checkbox
            >
            <input matInput hidden />
          </mat-form-field>
        </div>
        <div class="col-3" 
          *ngIf="!mainFormGroup?.controls?.isHidden.value &&
                  mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_CONTRACT_CODE">
          <mat-form-field class="no-underline">
            <label class="mr-2"></label>
            <mat-checkbox color="primary" formControlName="isRequired">{{
              "document_template.lbl_is_required" | translate
            }}</mat-checkbox>
            <input matInput hidden />
          </mat-form-field>
        </div>
        <div
          class="row col-6"
          *ngIf="
            mainFormGroup?.controls?.dataType?.value &&
            mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_SELECT &&
            mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_FIXED &&
            mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_CONTRACT_CODE
          "
        >
          <div class="col-6">
            <mat-form-field class="min_max">
              <input
                (focusout)="focusOut('minLength')"
                matInput
                type="number"
                min="0"
                max="4000"
                formControlName="minLength"
                [pattern]="descriptPattern"
                [placeholder]="'document_template.lbl_min_length' | translate"
              />
              <button
                mat-button
                type="button"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                *ngIf="mainFormGroup.controls.minLength.value"
                (click)="clearData('minLength')"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="isError('minLength', 'checkMinLength')">
                {{ "validation.format_descript_length" | translate }}
              </mat-error>
              <mat-error
                *ngIf="
                  !isError('minLength', 'checkMinLength') &&
                  mainFormGroup.controls.minLength.errors?.pattern
                "
              >
                {{ "validation.format_descript_length" | translate }}
              </mat-error>
              <mat-error
                *ngIf="
                  isError('minLength', 'checkLess') &&
                  mainFormGroup.controls.maxLength.value &&
                  !isError('minLength', 'checkMinLength')
                "
              >
                {{ "validation.minLength_is_less_than_maxLength" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6" 
            *ngIf="mainFormGroup?.controls?.dataType?.value !== DATA_TYPE_CONTRACT_CODE">
            <mat-form-field class="min_max">
              <input
                (focusout)="focusOut('maxLength')"
                matInput
                type="number"
                min="0"
                max="4000"
                formControlName="maxLength"
                [pattern]="descriptPattern"
                [placeholder]="'document_template.lbl_max_length' | translate"
              />
              <button
                mat-button
                type="button"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                *ngIf="mainFormGroup.controls.maxLength.value"
                (click)="clearData('maxLength')"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="isError('maxLength', 'checkMaxLength')">
                {{ "validation.format_descript_length" | translate }}
              </mat-error>
              <mat-error
                *ngIf="
                  isError('maxLength', 'checkGreater') &&
                  mainFormGroup.controls.minLength.value &&
                  !isError('maxLength', 'checkMaxLength')
                "
              >
                {{
                  "validation.maxLength_is_greater_than_minLength" | translate
                }}
              </mat-error>
              <mat-error
                *ngIf="
                  !isError('maxLength', 'checkMaxLength') &&
                  mainFormGroup.controls.maxLength.errors?.pattern
                "
              >
                {{ "validation.format_descript_length" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field>
            <textarea
              (focusout)="focusOut('note')"
              matInput
              name="note"
              id="note"
              rows="2"
              maxlength="500"
              formControlName="note"
              [placeholder]="'document_template.lbl_note' | translate"
              style="min-height: 50px"
            ></textarea>
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup.controls.note.value"
              (click)="clearData('note')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="isError('category', 'maxLength')">
              {{ "document_template.validate_note_max_length" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </section>
</mat-dialog-content>
<div class="fix-button text-center">
  <button mat-stroked-button color="primary" class="mr-3" (click)="cancel()">
    <mat-icon class="mr-0">cancel</mat-icon>{{ "form.cancel" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="submitForm()">
    <mat-icon class="mr-0">save</mat-icon>
    <span *ngIf="mode === 'create'">{{ "form.create" | translate }}</span>
    <span *ngIf="mode === 'edit'">{{ "form.update" | translate }}</span>
  </button>
</div>
